import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, Renderer2, ViewContainerRef } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { AuthData } from "sharedFeatures/sharedModels";
import { WindowComponent } from "sharedFeatures/window";
import { AuthUtils } from 'sharedFeatures/utils';
import { UpgradeWinBodyComponent } from './upgrade-win-body.component';
import { LicenseStatus } from "sharedFeatures/enums";

@Component({
    selector: 'upgrade-win',
    templateUrl: '../window/window.component.html',
    styleUrls: ['../window/window.component.less']
})
export class UpgradeWin extends WindowComponent implements OnDestroy, AfterViewInit {

    resizeObservable$ = fromEvent(window, 'resize');
    resizeSubscription$?: Subscription;
    disableScroll = false;
    constructor(element: ElementRef,
        r: Renderer2,
        viewContainerRef: ViewContainerRef,
        chDet: ChangeDetectorRef,
        private ngZone: NgZone
    ) {

        super(element, r, viewContainerRef, chDet);

        this.width = -1;
        this.height = -1;
        this.showClose = false;
        this.isModal = true;
        this.title = '';
        this.testId = 'UpgradeSubscriptionWindow';
        this.cornerRadius = 0;
        this.topMargin = 20;

        this.windowContentBody = UpgradeWinBodyComponent;
    }

    getBodyComponent(): UpgradeWinBodyComponent {

        return <UpgradeWinBodyComponent>super.getBodyComponent();

    }

    public isTeamOwner: boolean = false;

    authData: AuthData = new AuthData();

    public initParams(
        subscriptionRef: string,
        priceOptionCodes: string[],
        licenseStatus: string,
        productVersion: string,
        licenseCompanies: string,   
        licenseEndDate: string = ''

    ): void { 
        let licenseFrequency = AuthUtils.getLicenseFrequency(priceOptionCodes);
        let packageType = AuthUtils.getLicensePackageType(priceOptionCodes);
        
        this.getBodyComponent().initSubscriptionParams(
            subscriptionRef,
            licenseFrequency,
            packageType,
            productVersion,
            licenseCompanies,
            '',
            licenseStatus,
            priceOptionCodes,
            licenseEndDate
        );

        //this.getBodyComponent().getCurrentLicensePackage(licenseStatus, priceOptionCodes);
        
        this.isTeamOwner = (this.authData.teamOwnerId == 0 || this.authData.teamOwnerId == this.authData.userID);
    }

    public setAuthData(data: AuthData): void {
        this.authData = data;

        this.initParams(
            data.subscriptionID,
            data.priceOptionCodes,
            data.licenseStatus ? data.licenseStatus : '',
            data.productVersion,
            data.licenseCompanies
        );
        
    }

    ngAfterViewInit() {
        this.ngZone.runOutsideAngular(() => {
            this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {
                const target = evt.target as Window;
                this.setSize(target.innerWidth, target.innerHeight > document.body.scrollHeight ? target.innerHeight : document.body.scrollHeight);
            });
        });
        super.ngAfterViewInit();
    }

    ngOnDestroy() {
        this.resizeSubscription$?.unsubscribe();
    }
}
